import BoundaryError from 'common/components/BoundaryError'
import { fetchInstances } from 'supervision/instances/InstancesSlice'
import NavBar from 'common/components/NavBar'
import React, { useCallback, useEffect } from 'react'
import { shallowEqual, useDispatch, useSelector } from 'react-redux'
import { Outlet, useLocation } from 'react-router'
import { fetchCommercialFeatures } from 'gdl/commercial/commercialFeature/CommercialFeaturesSlice'
import { fetchCustomers, reset, selectCustomers } from 'gdl/customers/CustomersSlice'

const CustomersApp = () => {
    const { pathname } = useLocation()
    const dispatch = useDispatch()

    // Source unique : le store redux (fetchCustomers est gardé par une condition IDLE, donc pas de
    // double appel avec les écrans enfants qui lisent aussi le store). Évite le fetch redondant de la
    // liste clients (~11 kB) qui était fait ici via useFetch en plus de la slice.
    const customers = useSelector(selectCustomers, shallowEqual)

    useEffect(() => {
        dispatch(fetchInstances())
        dispatch(fetchCommercialFeatures())
        dispatch(fetchCustomers())
    }, [dispatch])

    const reloadCustomers = useCallback(() => {
        dispatch(reset())
        dispatch(fetchCustomers())
    }, [dispatch])

    const links = [
        { icon: 'business_center', tooltip: 'Clients', url: '/customer/dashboard' },
        { icon: 'person', tooltip: 'Contacts', url: '/customer/contacts' },
        { icon: 'inventory_2', tooltip: 'Lots', url: '/customer/lots' },
        { icon: 'lightbulb', tooltip: 'Idées', url: '/customer/ideas' },
    ]
    return (
        <>
            <NavBar links={links} />
            <BoundaryError url={pathname}>
                <div style={{ marginLeft: '65px' }}>
                    <Outlet
                        context={{ customers, reloadCustomers }}
                    />
                </div>
            </BoundaryError>
        </>
    )
}

export default CustomersApp
